import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Container,
    Snackbar,
    Alert,
} from "@mui/material";

import Navbar from "../Navbar";
import * as apiIngresoRemitos from "./api";
import * as helpers from "../ventas/facturacion/helpers";
import * as apiVtasFact from "../ventas/facturacion/api";
import FormDatosRemito from "./components/FormDatosRemitos";
import FormItems from "./components/FormItems";

import Footer from "./components/Footer";
import {getData} from "../../services/library";
import Header from "../Header";

const BRAND = {
  main: "#2471A3",
  dark: "#1B4F72",
  light: "#EAF2F8",
  accent: "#F39C12",
  surface: "#F4F7F9",
  border: "#E1E8ED",
};

function AddRemitos() {
    const [clientes, setClientes] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState();
    const [direcciones, setDirecciones] = useState([]);
    const [direccionSeleccionada, setDireccionSeleccionada] = useState();
    const [um, setUM] = useState(); 
    const [toast, setToast] = useState(null);
    const [disBtn, setDisBtn]=useState(false);
    const navigate = useNavigate();
    const [paramsNegocios, setParamsNegocios] = useState(); 

    const [dataRemito, setDataRemito] = useState({
        puntoVenta:"",
        nroComprobante:"",
        fecha: null,
        id_empresa:"",
        id_sucursal_remite: "",
        id_tipo_cliente: "",
        id_cliente: "",
        id_direccion_entrega: "",
        id_chofer: "",
        id_estado: 1,
        usuario_crea: localStorage.getItem("user"),
    });

    const [productos, setProductos] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [choferes, setChoferes] = useState([]);
    const [itemsRemito, setItemsRemito] = useState([
        {
            cantidad: "",
            unidadMedida: "",
            idProducto: "",
        },
    ]);

    useEffect(() => {
        apiIngresoRemitos.getParamsNegocios(setParamsNegocios);
        apiIngresoRemitos.getEmpresas(setEmpresas);
        // apiIngresoRemitos.getChoferes(setChoferes);
        apiVtasFact.getUnidadesMedida(setUM);
        apiIngresoRemitos.obtenerProductos(setProductos)
    }, []);

    useEffect(() => {
        !!clienteSeleccionado &&
            apiVtasFact.fetchDomicilios(
                clienteSeleccionado,
                setDirecciones,
                paramsNegocios
            );
    }, [clienteSeleccionado]);

    useEffect(()=>{
        if(!!direccionSeleccionada){
            setItemsRemito([{
                ...dataRemito,
                unidadMedida:2,
                cantidad: "",
                idProducto: direccionSeleccionada?.id_producto,
            }])
        }
    },[direccionSeleccionada])

    useEffect(()=>{
        if(!!dataRemito.id_empresa) {
            getData(`/sucursales/empresayotra/${dataRemito.id_empresa}`, setSucursales)
        }
    },[dataRemito.id_empresa])

    const buscaRepeticion =  async (remito) =>{
        if(remito.nroComprobante && remito.puntoVenta){
            const existe = await apiIngresoRemitos.fetchNroRemito(remito);
            console.log(existe)
            if(Boolean(existe.length)){
                setToast({severity:"error", msg:"El remito ya existe", onClose:()=>setToast(null)})
                setDataRemito({...dataRemito, nroComprobante:"", puntoVenta:""})
            }
        }
    }

    const almacenar = (e) => {
        setDataRemito({ ...dataRemito, [e.target.name]: e.target.value });
    };

    const handleOnChangeItemsRemito = (e, index) => {
        const values = [...itemsRemito];
        const updatedValue = e.target.name;
        values[index][updatedValue] = e.target.value;

        setItemsRemito(values);
    };

    const handleOnChangeUM = (e, index) => {
        const idProductoLinea = itemsRemito[index].idProducto;

        if (!!idProductoLinea) {
            const productoValido = helpers.validaUMProducto(
                productos,
                idProductoLinea,
                e.target.value
            );

            setItemsRemito((prev) => {
                const newItems = [...prev];
                newItems[index].unidadMedida = e.target.value;
                newItems[index].descUnidadMedida =
                    um
                        .find((un) => un.id === e.target.value)
                        ?.abreviatura?.toUpperCase() || "";
                newItems[index].idProducto = !productoValido
                    ? ""
                    : itemsRemito[index].idProducto;
                newItems[index].descripcion = "";
                return newItems;
            });
            return;
        }

        setItemsRemito((prev) => {
            const newItems = [...prev];
            newItems[index].unidadMedida = e.target.value;
            newItems[index].descUnidadMedida =
                um.find((un) => un.id === e.target.value)?.abreviatura?.toUpperCase() ||
                "";
            return newItems;
        });
    };

    const handleOnChangeProducto = (producto, index) => {
        const nuevosItems = [...itemsRemito];

        nuevosItems[index].idProducto = producto.idproducto;

        nuevosItems[index].descripcion = producto.detalle_factura;

        nuevosItems[index].valor_iva = producto.valor_iva;

        setItemsRemito(nuevosItems);
    };

    const handleNuevoItem = () => {
        const values = [...itemsRemito];
        values.push({
            cantidad: "",
            unidadMedida: "",
            idProducto: "",
        });
        setItemsRemito(values);
        setTimeout(() => {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
            });
        }, 100);
    };

    const handleEliminarItem = (index) => {
        const values = [...itemsRemito];
        values.splice(index, 1);
        setItemsRemito(values);
    };

    const remitoParams = {
        almacenar,
        dataRemito,
        setDataRemito,
        clientes,
        setClientes,
        clienteSeleccionado,
        setClienteSeleccionado,
        direccionSeleccionada,
        setDireccionSeleccionada,
        direcciones,
        setDirecciones,
        sucursales,
        setSucursales,
        choferes,
        setChoferes,
        empresas,
        buscaRepeticion
    };

    const [lineasCompletas, setLineasCompletas]=useState(0);
    const itemsParams = {
        itemsRemito,
        um,
        productos,
        handleOnChangeItemsRemito,
        handleOnChangeUM,
        handleNuevoItem,
        handleOnChangeProducto,
        handleNuevoItem,
        handleEliminarItem,
        lineasCompletas,
        setLineasCompletas
    };

    const enviar = async () => {
        setDisBtn(true)
        apiIngresoRemitos.enviarRemito({
            dataRemito,
            itemsRemito,
            clienteSeleccionado,
            direccionSeleccionada,
            setToast
        });

    };

    const hayCliente = !!clienteSeleccionado && !!direccionSeleccionada

    return (
        <div>
            <Navbar />
            <Box
                sx={{
                    minHeight: "95vh",
                    bgcolor: "background.default",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box component="main" sx={{ flex: 1, pb: 12 }}>
                    <Container maxWidth="xl" sx={{ py: { xs: 2.5, md: 4 } }}>
                        <Header title={"Carga De Remitos"} subtitle={""} BRAND={BRAND} />
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                            <FormDatosRemito {...remitoParams} />
                            <FormItems {...itemsParams} />
                        </Box>
                    </Container>
                </Box>
                <Footer 
                    clienteSeleccionado={clienteSeleccionado} 
                    enviar={enviar} 
                    dataRemito={dataRemito}
                    hayCliente={hayCliente}
                    disBtn={disBtn}
                    lineasCompletas={lineasCompletas}
                    itemsRemito={itemsRemito}
                />
                <Snackbar
                    open={!!toast}
                    autoHideDuration={3000}
                    onClose={() => toast?.onClose || navigate("/remitos")}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    {toast ? (
                        <Alert
                            severity={toast.severity}
                            variant="filled"
                            onClose={() => setToast(null)}
                        >
                            {toast.msg}
                        </Alert>
                    ) : undefined}
                </Snackbar>
            </Box>
        </div>
    );
}

export default AddRemitos;
